import { render, staticRenderFns } from "./ViewWalletInfoLayout.vue?vue&type=template&id=5a0ed312&scoped=true&"
import script from "./ViewWalletInfoLayout.vue?vue&type=script&lang=js&"
export * from "./ViewWalletInfoLayout.vue?vue&type=script&lang=js&"
import style0 from "./ViewWalletInfoLayout.vue?vue&type=style&index=0&id=5a0ed312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0ed312",
  null
  
)

export default component.exports